import { useState, useEffect } from 'react'
import { InviteService } from '../services'

export const useInvite = () => {
  const [invite, setInvite] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchMyInvite = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await InviteService.getMyInvite()
      setInvite(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const generateNewInvite = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await InviteService.generateInvite()
      setInvite(data)
      return data
    } catch (err) {
      setError(err.message)
      return null
    } finally {
      setLoading(false)
    }
  }

  const validateInvite = async (inviteId) => {
    setLoading(true)
    setError(null)
    try {
      const data = await InviteService.validateInvite(inviteId)
      return data
    } catch (err) {
      setError(err.message)
      return null
    } finally {
      setLoading(false)
    }
  }

  const getInviteFromUrl = () => {
    return InviteService.getInviteFromUrl()
  }

  useEffect(() => {
    fetchMyInvite()
  }, [])

  return {
    invite,
    loading,
    error,
    fetchMyInvite,
    generateNewInvite,
    validateInvite,
    getInviteFromUrl,
  }
}
